import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { validateLogin } from "../../services/validate-login";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { Combobox } from "@headlessui/react";
import { ArrowRight, ChevronsUpDown, Check, ArrowLeft } from "lucide-react";
import { companies } from "../../data/companies";
import { FixedSizeList as List } from "react-window"; // 👈 virtualization
import { getFormattedDate } from "../../utils/dateFormat";
import { sendEmailOtp, verifyEmailOtp } from "../../services/userService";

function Form() {
  const [employmentType, setEmploymentType] = useState(localStorage.getItem("employmentType")??"Salaried");
  const [annualIncome, setAnnualIncome] = useState(localStorage.getItem("annualIncome")??"");
  const [companyName, setCompanyName] = useState<string | null>(localStorage.getItem("companyName")??"");
  const [companyType, setCompanyType] = useState(localStorage.getItem("companyType")??"Private Limited");
  const [professionalEmail, setProfessionalEmail] = useState(localStorage.getItem("professionalEmail")??"");
  const [loanPurpose, setLoanPurpose] = useState(localStorage.getItem("loanPurpose")??"Purchase of Consumer Durables");
  const [query, setQuery] = useState("");
  const [formIsComplete, setFormIsComplete] = useState(false);   
  const [emailError1, setEmailError1] = useState(true);
  const [emailError2, setEmailError2] = useState("");
  const [emailError3, setEmailError3] = useState("");
  const [emailErrors, setEmailErrors] = useState<string[]>([]);
  // Add these states near the top of Form()
  const [isEmailVerified, setIsEmailVerified] = useState(localStorage.getItem("emailVerified") === "true");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [otpError, setOtpError] = useState("");

  const navigate = useNavigate();
  
    useEffect(() => {
      async function getStep() {
        if(Number(localStorage.getItem("step")) >= 2){checkForm();localStorage.setItem("step","1")} else{ navigate("/personal-loan") }
      }
      getStep();
    }, []);

  // const validateEmail = (value: string) => {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  //   if (!emailRegex.test(value)) {
  //     setEmailError1("i. company email required");
  //     setEmailError2("ii. @gmail/yahoo/live not allowed");
  //     setEmailError3("iii. incorrect details will lead to termination of loan application");
  //   } else {
  //     setEmailError1("");
  //     setEmailError2("");
  //     setEmailError3("");
  //   }
  // };

//   const validateEmail = (val: string) => {
//   const errors: string[] = [];

//   // Basic format check
//   if (!val) {
//     errors.push("Company Email is required.");
//   } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
//     errors.push("Enter a valid email address.");
//   } else {
//     // Restricted domains
//     const restrictedDomains = ["gmail.com", "yahoo.com", "live.in", "live.com"];
//     const domain = val.split("@")[1]?.toLowerCase();

//     if (restrictedDomains.includes(domain)) {
//       errors.push(`Emails from ${domain} are not allowed. Please use your professional email.`);
//     }
//   }
//   if(errors.length == 0) setEmailError1(true)
//   setEmailErrors(errors);
// };

  // const checkForm = () => {
  //   console.log(emailError1)
  //   if(employmentType != "" && annualIncome != "" && companyName != "" && companyType != "" && professionalEmail != "" && loanPurpose != ""  && emailError1){
  //     setFormIsComplete(true)
  //   }else{
  //     setEmailError1(false)
  //     setFormIsComplete(false)
  //   }
  // }

  useEffect(() => {
    console.log("Email verified:", isEmailVerified);
    checkForm()
  }, [isEmailVerified]);

  const validateEmail = (val: string) => {
    const errors: string[] = [];

    if (!val) {
      errors.push("Company Email is required.");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
      errors.push("Enter a valid email address.");
    } else {
      const restrictedDomains = ["gmail.com", "yahoo.com", "live.in", "live.com"];
      const domain = val.split("@")[1]?.toLowerCase();

      if (restrictedDomains.includes(domain)) {
        errors.push(`Emails from ${domain} are not allowed. Please use your professional email.`);
      }
    }
    setEmailErrors(errors);
  };

  const sendOtp = async () => {
    // Mock sending OTP logic
    if (emailErrors.length > 0 || !professionalEmail) {
      alert("Please enter a valid company email before verifying.");
      return;
    }

    // // Generate random 6-digit OTP
    // const newOtp = Math.floor(100000 + Math.random() * 900000).toString();
    // setGeneratedOtp(newOtp);
    // console.log("OTP sent to:", professionalEmail, "->", newOtp); // mock console

    const response = await sendEmailOtp(professionalEmail);
    console.log(response)
    setShowOtpModal(true);
    setOtp("");
    setOtpError("");
  };

    const verifyOtp = async () => {
      const response = await verifyEmailOtp(otp);
      if (response.success) {
        setIsEmailVerified(true);
        localStorage.setItem("emailVerified", "true");
        setShowOtpModal(false);
        alert("Email verified successfully!");
      } else {
        setOtpError("Invalid OTP. Please try again.");
      }
    };

  // const checkForm = () => {
  //   if (
  //       employmentType !== "" &&
  //       annualIncome !== "" &&
  //       companyName !== "" &&
  //       companyType !== "" &&
  //       professionalEmail !== "" &&
  //       loanPurpose !== "" &&
  //       emailErrors.length === 0
  //     ) {
  //       const errors: string[] = [];
  //       if (!professionalEmail) {
  //         errors.push("Company Email is required.");
  //       } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(professionalEmail)) {
  //         errors.push("Enter a valid email address.");
  //       } else {
  //         const restrictedDomains = ["gmail.com", "yahoo.com", "live.in", "live.com"];
  //         const domain = professionalEmail.split("@")[1]?.toLowerCase();

  //         if (restrictedDomains.includes(domain)) {
  //           errors.push(`Emails from ${domain} are not allowed. Please use your professional email.`);
  //         }
  //       }
  //       setEmailErrors(errors);
  //       if(errors.length === 0 )setFormIsComplete(true)
  //     } else {
  //       setFormIsComplete(false);
  //     }
  //   };

  const checkForm = () => {
    if (
      employmentType !== "" &&
      annualIncome !== "" &&
      companyName !== "" &&
      companyType !== "" &&
      professionalEmail !== "" &&
      loanPurpose !== "" &&
      emailErrors.length === 0 &&
      isEmailVerified
    ) {
      setFormIsComplete(true);
    } else {
      setFormIsComplete(false);
    }
  };


  const onClickEvent = () => {
    localStorage.setItem("employmentType", employmentType)
    localStorage.setItem("annualIncome", annualIncome)
    localStorage.setItem("companyName", companyName ?? "")
    localStorage.setItem("companyType", companyType)
    localStorage.setItem("professionalEmail", professionalEmail)
    localStorage.setItem("loanPurpose", loanPurpose)
    localStorage.setItem("step2TimeStamp", getFormattedDate())
    localStorage.setItem("step", "3")
    navigate("/account-aggregator")
  }

  // Filter based on search
  const filteredCompanies =
    query === ""
      ? companies
      : companies.filter((company) =>
          company.toLowerCase().includes(query.toLowerCase())
        );

  // Virtualized row renderer
  const Row = ({ index, style }: { index: number; style: React.CSSProperties }) => {
    const company = filteredCompanies[index];
    return (
      <Combobox.Option key={index} value={company}>
        {({ active, selected }) => (
          <div
            style={style}
            className={`px-4 py-2 cursor-pointer ${
              active ? "bg-blue-600 text-white" : "text-gray-900"
            }`}
          >
            {selected && <Check className="h-4 w-4 inline mr-2 text-blue-600" />}
            {company}
          </div>
        )}
      </Combobox.Option>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#f5f9ff] px-4">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row max-w-5xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Left side Image (fixed) */}
        <div className="basis-full md:basis-2/5 flex items-center justify-center p-6 bg-gray-50 md:h-[calc(100vh-100px)] md:sticky md:top-0">
          <img
            src="svg/img2.svg"
            alt="Working professional"
            className="w-full max-w-xs md:max-w-none object-contain"
          />
        </div>

        {/* Right side Form (scrollable) */}
        <div className="basis-full md:basis-3/5 flex flex-col p-8 bg-white relative md:h-[calc(100vh-100px)] md:overflow-y-auto">
          {/* Step Number */}
          <div className="absolute top-4 right-4 bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
            Step 3
          </div>
          {/* Scrollable content */}
          <div className="flex-1 overflow-y-auto">
            <h2 className="text-xl font-semibold mb-6">PERSONAL LOAN APPLICATION</h2>
            <p className="text-sm text-gray-600 mb-4">
              Please verify your information
            </p>

            {/* Extra Fields */}
            <div className="space-y-6">
              {/* Employment Type */}
              <div>
                <label className="block text-sm text-gray-600 mb-1">Employment Type</label>
                <select
                  value={employmentType}
                  onClick={(e) => checkForm()}
                  onKeyDown={(e) => checkForm()}
                  onChange={(e) => setEmploymentType(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                >
                  <option value="Salaried">Salaried</option>
                  <option value="Self-Employed">Self-Employed</option>
                </select>
              </div>

              {/* Annual Income Field */}
              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Annual Income
                </label>
                <div className="flex items-center border border-gray-300 rounded-lg">
                  <span className="px-3 text-gray-600">Rs.</span>
                  <input
                    type="number"
                    value={annualIncome}
                    onKeyUp={(e) => checkForm()}
                    onChange={(e) => setAnnualIncome(e.target.value)}
                    placeholder="Enter annual in-hand or take home salary"
                    className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                  />
                </div>
              </div>

              {/* Autocomplete Dropdown with Virtualized List */}
              <div className="relative">
                <label className="block text-sm text-gray-600 mb-1">Company Name</label>
                <Combobox value={companyName} onChange={setCompanyName}>
                  <div className="relative">
                    <Combobox.Input
                      type="text"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                      displayValue={(value: string) => value || ""}
                      onChange={(event) => {
                        setCompanyName(event.target.value); // <-- keep typed value
                        setQuery(event.target.value);
                      }}
                      placeholder="Search Company Name..."
                    />

                    <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-3">
                      <ChevronsUpDown className="h-5 w-5 text-gray-400" />
                    </Combobox.Button>
                  </div>

                  {filteredCompanies.length > 0 && (
                    <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full bg-white shadow-lg rounded-lg">
                      <List
                        height={240} // dropdown height
                        itemCount={filteredCompanies.length}
                        itemSize={35} // row height
                        width="100%"
                      >
                        {Row}
                      </List>
                    </Combobox.Options>
                  )}
                </Combobox>
              </div>

              {/* Company Type */}
              <div>
                <label className="block text-sm text-gray-600 mb-1">Company Type</label>
                <select
                  value={companyType}
                  onKeyUp={(e) => checkForm()}
                  onChange={(e) => setCompanyType(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                >
                  <option value="Private Limited">Private Limited</option>
                  <option value="Public Limited">Public Limited</option>
                  <option value="Propritorship">Propritorship</option>
                  <option value="LLP">LLP</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              {/* Professional Email */}
              <div>
                <label className="block text-sm text-gray-600 mb-1">Professional Email</label>
                <div className="flex gap-2">
                  <input
                    type="email"
                    value={professionalEmail}
                    onKeyUp={checkForm}
                    onChange={(e) => {
                      const val = e.target.value.trim();
                      setProfessionalEmail(val);
                      validateEmail(val);
                      setIsEmailVerified(false);
                      localStorage.setItem("emailVerified", "false");
                    }}
                    placeholder="name@yourcompany.com"
                    className={`w-full border rounded-lg px-4 py-2 focus:ring-2 outline-none ${
                      emailErrors.length > 0
                        ? "border-red-500 focus:ring-red-500"
                        : professionalEmail
                        ? "focus:ring-blue-500"
                        : "border-blue-300 focus:ring-blue-500"
                    }`}
                  />

                  <button
                    type="button"
                    onClick={sendOtp}
                    className={`px-4 py-2 rounded-lg font-semibold text-white ${
                      isEmailVerified ? "bg-green-500 cursor-default" : "bg-blue-600 hover:bg-blue-700"
                    }`}
                    disabled={isEmailVerified}
                  >
                    {isEmailVerified ? "Verified" : "Verify"}
                  </button>
                </div>

                {emailErrors.map((err, idx) => (
                  <p key={idx} className="text-red-500 text-sm mt-1">{err}</p>
                ))}
              </div>


              {/* Loan Purpose */}
              <div>
                <label className="block text-sm text-gray-600 mb-1">Loan Purpose</label>
                <select
                  value={loanPurpose}
                  onClick={(e) => checkForm()}
                  onKeyDown={(e) => checkForm()}
                  onChange={(e) => setLoanPurpose(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                >
                  <option value="Purchase of Consumer Durables">Purchase of Consumer Durables</option>
                  <option value="Education">Education</option>
                  <option value="Travel">Travel</option>
                  <option value="Health">Health</option>
                  <option value="Other Consumption Purpose">Other Consumption Purpose</option>
                </select>
              </div>
            </div>
          </div>

          {/* Next Buttons in a row */}
          <div className="mt-6 flex gap-4">
            <button
              className="flex-1 bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition flex items-center justify-center gap-2"
              onClick={() => navigate("/basic-details")}
            >
              <ArrowLeft size={18} /> Back 
            </button>
            
            <button
              className={`flex-1 px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
                ${formIsComplete
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "bg-gray-400 cursor-not-allowed"}`}
              onClick={onClickEvent}
              disabled={!formIsComplete}
            >
              Next <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
      {/* OTP Modal */}
{showOtpModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-80">
      <h3 className="text-lg font-semibold mb-2">Enter OTP</h3>
      <p className="text-sm text-gray-600 mb-4">
        A 6-digit code has been sent to <span className="font-medium">{professionalEmail}</span>
      </p>
      <input
        type="text"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        maxLength={6}
        placeholder="Enter OTP"
        className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-3 focus:ring-2 focus:ring-blue-500 outline-none"
      />
      {otpError && <p className="text-red-500 text-sm mb-2">{otpError}</p>}

      <div className="flex justify-end gap-2">
        <button
          className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
          onClick={() => setShowOtpModal(false)}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          onClick={verifyOtp}
        >
          Verify
        </button>
      </div>
    </div>
  </div>
)}


      {/* Footer Stats */}
      <Footer />
    </div>
  );
}

export default function Step3EmploymentDetails() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, [navigate]);

  return (
    <div className="flex flex-col h-screen overflow-y-auto">
      <div className="flex-shrink-0">
        <Header title="" />
      </div>

      {/* Main Content scrollable */}
      <main className="flex-1 overflow-y-auto">
          <Form />
      </main>
    </div>
  );
}
